import styled from 'styled-components';
import { palette, font } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';
import { logos } from '@iso/config/config';

const SignInStyleWrapper = styled.div`
  font-family: ${font('secondary')};
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  background: url(${process.env.PUBLIC_URL + '/images/images_config/' + logos.backgroundLogin}) no-repeat center center;
  background-size: cover;
  color:${palette('colorTextLogin', 0)};

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 1;
    top: 0;
    left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
    right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
  }

  .isoLoginContentWrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    z-index: 10;
    position: relative;
  }

  .isoLoginContent {
    width: 700px;
    margin-left:auto;
    margin-right:auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 70px 50px;
    position: relative;
    background-color: ${palette('transparent', 0)};
    justify-content:center;
    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 70px 20px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 80px;
      justify-content: center;
      flex-shrink: 0;

      @media only screen and (min-width: 576px) and (max-width: 767px) 
      {
        margin-bottom:70px;
      }
      @media only screen and (max-width: 575px) 
      {
        margin-bottom:60px;
      }

      a {
        font-size: 24px;
        font-weight: 300;
        line-height: 1;
        text-transform: uppercase;
        color: ${palette('secondary', 0)};
      }
      .img-login{
        width: 217px;
        height:auto;
        @media only screen and (min-width: 576px) and (max-width: 767px) 
        {
          width:240px;
        }
        @media only screen and (max-width: 575px) 
        {
          width:215px;
        }
      }
    }

    .isoSignInForm {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;

      form{
        width:360px;
        margin-left:auto;
        margin-right:auto;

        /*sm*/
        @media only screen and (min-width: 576px) and (max-width: 767px) 
        { 
          width:100%;
        }

        /*xs*/
        @media only screen and (max-width: 575px) 
        {
          width:100%;
        }
      }

      .isoInputWrapper {
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }
        .ant-form-item{
          margin-bottom: 5px;
        }

        input:not(.button-login) {
          color:${palette('colorInputLogin', 0)};
          background-color:transparent;
          border:none;
          border-bottom:1px solid ${palette('colorBorderInputLogin', 0)};
          font-size:${font('size', 0)};
          &::-webkit-input-placeholder 
          {
            color: ${palette('colorBorderInputLogin', 0)};
          }
          &:-moz-placeholder 
          {
            color: ${palette('colorBorderInputLogin', 0)};
          }
          &::-moz-placeholder 
          {
            color: ${palette('colorBorderInputLogin', 0)};
          }
          &:-ms-input-placeholder 
          {
            color: ${palette('colorBorderInputLogin', 0)};
          }
          &:focus{
            box-shadow:none;
          }
        }
      }

      .isoHelperText {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
        color: ${palette('grayscale', 1)};
        padding-left: ${props =>
          props['data-rtl'] === 'rtl' ? 'inherit' : '13px'};
        padding-right: ${props =>
          props['data-rtl'] === 'rtl' ? '13px' : 'inherit'};
        margin: 15px 0;
        position: relative;
        display: flex;
        align-items: center;

        &:before {
          content: '*';
          color: ${palette('error', 0)};
          padding-right: 3px;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 2px;
          left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
          right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
        }
      }

      .isoHelperWrapper {
        margin-top: 35px;
        flex-direction: column;
      }

      .isoOtherLogin {
        padding-top: 40px;
        margin-top: 35px;
        border-top: 1px dashed ${palette('grayscale', 2)};

        > a {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        button {
          width: 100%;
          height: 42px;
          border: 0;
          font-weight: 500;

          &.btnFacebook {
            background-color: #3b5998;

            &:hover {
              background-color: darken(#3b5998, 5%);
            }
          }

          &.btnGooglePlus {
            background-color: #dd4b39;
            margin-top: 15px;

            &:hover {
              background-color: darken(#dd4b39, 5%);
            }
          }

          &.btnAuthZero {
            background-color: #e14615;
            margin-top: 15px;

            &:hover {
              background-color: darken(#e14615, 5%);
            }
          }

          &.btnFirebase {
            background-color: ${palette('color', 5)};
            margin-top: 15px;

            &:hover {
              background-color: ${palette('color', 6)};
            }
          }

          &.btnAccountKit {
            ${'' /* background-color: rgb(150, 189, 235); */}
            margin-top: 15px;

            &:hover {
              ${'' /* background-color: ${palette('color', 6)}; */}
            }
          }
        }
      }

      .isoForgotPass {
        margin-bottom: 10px;
        text-decoration: none;
        &:hover {
          color: ${palette('colorTextLogin', 0)};
        }
      }

      button {
        font-weight: 500;
      }
    }
  }

  .text-sponsors{
    padding-top:40px;
    font-weight:300;
    text-align:center;
  }

  .logos-sponsors{
    display:flex;
    flex-wrap:wrap;
    justify-content: center;
    margin-bottom:15px;
    /*sm*/
    @media only screen and (min-width: 576px) and (max-width: 767px) 
    { 
      & > div
      {
        width:50%;
        text-align:center;
        margin-bottom:25px;
      }
    }

    /*xs*/
    @media only screen and (max-width: 575px) 
    {
      & > div
      {
        width:50%;
        text-align:center;
        margin-bottom:25px;
      }
    }
  }

  a {
    color:${palette('colorTextLogin', 0)};
    &:hover,&:active,&:focus
    {
      color:${palette('colorTextLogin', 0)};
    }
  }

  .row-logoslogin{
    margin-top:30px;
    padding-left:10%;
    padding-right:10%;
    @media only screen and (min-width: 576px) and (max-width: 767px) 
    { 
      padding-left:0px;
      padding-right:0px;
    }

    /*xs*/
    @media only screen and (max-width: 575px) 
    {
      padding-left:0px;
      padding-right:0px;
    }
    img{
      max-width:100%;
      height:auto;
    }
  }
  .text-register-password {
  color:${palette('bgTextLogoLogin', 0)};
  }
  .text-register {
    color:${palette('colorTextLogoLogin', 0)};
    margin-bottom: 10px;
  }
  .password-instruction{
    color:${palette('colorTextLogoLogin', 0)};
    opacity: 0.7;
    font-size: small;
    margin-top: 5px;
  }
  .react-pass-verify{
    //width: 126%;
    //@media only screen and (max-width: 575px) {
    //  width: 90%;
    //}
  }

`;

export default WithDirection(SignInStyleWrapper);
